<template>
  <form v-if="editableIntegration" class="page-content -no-padding" @submit.prevent="submit">
    <label>
      Label
      <input v-model="editableIntegration.label" type="text" />
      <span v-if="labelError()" class="alert -inline -danger">Label {{ labelError() }}</span>
    </label>

    <label>
      Platform
      <select v-model="editableIntegration.platform">
        <option>-</option>
        <option value="fb_messenger">Facebook Messenger</option>
      </select>
      <span v-if="platformError()" class="alert -inline -danger">Platform {{ platformError() }}</span>
    </label>

    <label v-if="editableIntegration.platform === 'fb_messenger'">
      Facebook Page ID
      <input v-model="editableIntegration.metadata.fb_page_id" type="text" />
      <span v-if="metadataError('fb_page_id')" class="alert -inline -danger"
        >Facebook page id {{ metadataError("fb_page_id") }}</span
      >
    </label>

    <label v-if="editableIntegration.platform === 'fb_messenger'">
      Facebook Access Token
      <input v-model="editableIntegration.metadata.fb_access_token" type="text" />
      <span v-if="metadataError('fb_access_token')" class="alert -inline -danger"
        >Facebook access token {{ metadataError("fb_access_token") }}</span
      >
    </label>

    <hr />

    <action-button
      :state="state"
      :text="editableIntegration.id ? 'Update Integration' : 'Create Integration'"
      @pressed="submit"
    />
  </form>
</template>

<script>
import dig from "object-dig";

import actionButton from "@/components/actionButton";

export default {
  components: { actionButton },

  props: {
    integration: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      state: "normal",
      editableIntegration: null,
      errors: {}
    };
  },

  created() {
    this.editableIntegration = this.integration;
  },

  methods: {
    labelError() {
      if (this.errors.label) return this.errors.label[0];
      if (this.errors.unique_label) return this.errors.unique_label[0];
      return null;
    },

    platformError() {
      return dig(this.errors, "platform", 0);
    },

    metadataError(field) {
      return dig(this.errors, "metadata", field, 0);
    },

    submit() {
      if (this.state !== "normal") return;
      this.state = "loading";

      this.$store.dispatch("createIntegration", {
        integration: this.editableIntegration,
        callback: (err, resp) => {
          if (err) {
            this.state = "normal";
            this.errors = err.response.data.errors;
          } else {
            this.state = "done";
            setTimeout(() => {
              this.state = "normal";
            }, 3000);

            console.log("saved", resp);
            this.$emit("saved", resp.data.data.attributes);
          }
        }
      });
    }
  }
};
</script>
